import { render, staticRenderFns } from "./heroSectionHome.vue?vue&type=template&id=5139029e&"
import script from "./heroSectionHome.vue?vue&type=script&lang=js&"
export * from "./heroSectionHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports